<template>
  <div class="choose-alternative-methods">
    <div class="content">
      <h2>{{ $t("ChooseCreditCard.title") }}</h2>

      <div class="row">
        <div class="vendor creditcard">{{ $t("ChooseCreditCard.method") }}</div>
        <div v-if="region !== 'mena'" class="processingCards">
          {{ $t("ChooseCreditCard.processing") }}
        </div>
        <div v-if="region !== 'mena'" class="fee">{{ $t("ChooseCreditCard.fee") }}</div>
        <div class="arrow-right"></div>
      </div>

      <InfoRowButton
        v-for="option in optionsTheme"
        :key="option.icon"
        method=""
        :logo="option.icon"
        processing="null"
        :clase="option.clase"
        :cardsCheck="option.cardsCheck"
        :fee="option.fee"
        @click="addFunds(option.value)"
      ></InfoRowButton>

      <button class="cabinet-back" @click="back">
        <div class="icon"></div>
        {{ $t("ChooseCreditCard.back") }}
      </button>
    </div>

    <p class="method-instructions">
      {{ $t("ChooseCreditCard.instructionOne") }}
      <strong>
        <a href="/cabinet/console/contact_us">{{
          $t("ChooseCreditCard.contact")
        }}</a>
      </strong>
      {{ $t("ChooseCreditCard.instructionTwo") }}
      <br />
      <br />
      {{ $t("ChooseCreditCard.instructionThree") }}
    </p>
  </div>
  <Modal
    v-if="showDialog"
    @close="showDialog = false"
    dialogStyle="login-modal"
  >
    <template #body>
      <p>{{ $t("ChooseCreditCard.messageZotapay") }}</p>
    </template>
    <template #footer>
      <button @click="advisedZotapay">Ok</button>
    </template>
  </Modal>
</template>

<script>
import InfoRowButton from "@/components/InfoRowButton";
import { onMounted, ref } from "@vue/runtime-core";
import { getCurrentInstance } from "@vue/runtime-core";
import store from "@/store";
import Modal from "../../components/Modal";
import { i18n } from "@/plugins/i18n";

export default {
  name: "ChooseCreditCard",
  components: {
    InfoRowButton,
    Modal,
  },
  data() {
    return {
      showDialog: false,
    };
  },
  methods: {
    back() {
      this.$router.back();
    },
    addFunds(target) {
      this.$router
        .push("/cabinet/console/add_funds_creditcar/" + target)
        .catch((err) => {});
    },

    advisedZotapay() {
      this.showDialog = false;
      this.$router
        .push("/cabinet/console/add_funds/ZOTAPAY")
        .catch((err) => {});
    },
  },
  setup() {
    let optionsTheme = ref([]);
    let region = ref(process.env.VUE_APP_CABINET_ORIGIN);
    let options = ref([
      {
        icon: "/assets/images/logo_ecommpay.svg",
        processing: "Instant 24/7",
        fee: "0%",
        value: "ECOMMPAY",
        name: "ECOMMPAY",
        cardsCheck: true,
      },
      {
        icon: "/assets/images/logo_zotapay.svg",
        processing: "3 - 5 days",
        fee: "0%",
        value: "ZOTAPAY",
        name: "ZOTAPAY",
        cardsCheck: true,
        clase: "logoZotapay",
      },
    ]);

    let optionsLight = ref([
      {
        icon: "/assets/images/logo_ecommpay.svg",
        processing: "Instant 24/7",
        fee: "0%",
        value: "ECOMMPAY",
        name: "ECOMMPAY",
        cardsCheck: true,
      },
      {
        icon: "/assets/images/logo_zotapay_light.svg",
        processing: "3 - 5 days",
        fee: "0%",
        value: "ZOTAPAY",
        name: "ZOTAPAY",
        cardsCheck: true,
        clase: "logoZotapay",
      },
    ]);

    const internalInstance = getCurrentInstance();
    const emitter = internalInstance.appContext.config.globalProperties.emitter;

    onMounted(() => {
      emitter.on("preferencesUpdated", () => {
        imgSite();
      });
    });

    const imgSite = () => {
      let theme = store.state.preferences.theme;
      optionsLight.value = [];
      let platforms_pay_storage = JSON.parse(
        localStorage.getItem("DepositMethods")
      );
      platforms_pay_storage = platforms_pay_storage.creditcard;
      for (var plat in platforms_pay_storage) {
        optionsLight.value.push({
          icon: "/assets/images/" + platforms_pay_storage[plat].icon,
          processing: platforms_pay_storage[plat].processing,
          fee: platforms_pay_storage[plat].free,
          value: plat,
          clase: platforms_pay_storage[plat].clase,
        });
      }
      optionsTheme.value = optionsLight.value;

      // if (i18n.global.locale !== "ar") {
      //   let newOptions = optionsLight.value.filter(
      //     (obj) => obj.value !== "myfatoorah"
      //   );
      //   optionsTheme.value = newOptions;
      // }
      // if (theme == 'LIGHT') {
      //   optionsTheme.value = optionsLight
      // }
      // if (theme == 'DARK') {
      //   optionsTheme.value = options
      // }
    };

    imgSite();

    return {
      optionsTheme,
      imgSite,
      region
    };
  },
};
</script>

<style scoped>
</style>
